var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#C29B40",
    d: "m15.782 11.73.01 3a1.5 1.5 0 0 1-1.497 1.505l-10.5.03a1.5 1.5 0 0 1-1.504-1.495l-.009-3m6.724-9.02.025 8.625m0 0 3.74-3.76m-3.74 3.76-3.76-3.74"
  })));
};
export default SvgDownload;